import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IMSTATUS } from '@/config/enum';
import { selectgm } from '@/redux/im/action';
import { IM_MESSAGE } from '@/typings/global';
import { MyThunkResult } from '@/typings/reducer';

function Notice({ type, message }: IM_MESSAGE): JSX.Element {
    const dispatch: MyThunkResult<Promise<any>, any> = useDispatch();
    const { STATUS } = useSelector(({ IMReducer }) => ({
        STATUS: IMReducer.STATUS
    }));
    const _handleSelect = async (e) => {
        const {
            // 标签名称
            target: { localName, className }
        } = e;

        if (localName === 'em') {
            // 手动选择客服
            if (className === 'gm-online-item-0' || className === 'gm-online-item-1') {
                try {
                    if (STATUS.status >= IMSTATUS.PROCESSING && STATUS.status !== IMSTATUS.ENDED) {
                        return IM.IMServer.notice('info', '您正在与客服进行对话，无法选择客服。');
                    }
                    const id = e.target.getAttribute('data-id');
                    await dispatch(selectgm(id));
                    IM.IMServer.loop();
                } catch {
                    IM.IMServer.iswakeup({ actived: 1 });
                }
            }
            //  留言
            if (className === 'act-comment') {
                if (STATUS.COMMENTED) {
                    return IM.IMServer.notice('warn', '您已提交过留言');
                }
                if (STATUS.status >= IMSTATUS.PROCESSING && STATUS.status !== IMSTATUS.ENDED) {
                    return IM.IMServer.notice('info', '您正在与客服进行对话，无法使用留言方式。');
                }
                IM.handlePopup({ popup: 'comment', open: true });
            }
        }
        if (localName === 'span') {
            // 重新链接客服
            if (className === 'win-reload') {
                IM.IMServer.reconnect();
            }
        }
    };
    return (
        <li className={`im-message-tip im-message-${type}`} onClick={_handleSelect}>
            {type === 'gm-revoke' ? (
                <span>对方撤回了一条消息</span>
            ) : (
                <span dangerouslySetInnerHTML={{ __html: message }} />
            )}
        </li>
    );
}

export default Notice;
